export default __webpack_public_path__ + "static/media/unknown.8b009a4e.svg";